import React from 'react';
import { Typography } from '@vp/swan';
import PropTypes from 'prop-types';

function CheckoutWarning({ shown, warningText }) {
  return shown ? (
    <Typography component="span" textColor="alert" fontSize={1}>
      {warningText}
    </Typography>
  ) : null;
}

CheckoutWarning.propTypes = {
  shown: PropTypes.bool.isRequired,
  warningText: PropTypes.string.isRequired,
};

export default CheckoutWarning;
